import { Injectable } from '@angular/core';
import * as lodhash from 'lodash';
import { GmapsViewComponent } from '../gmaps-view/gmaps-view.component';
import { environment } from '../../../environments/environment';
import { GetJsonObjectService } from '../services/get-json-object.service';
import { first, map, Observable } from 'rxjs';
import { OverlayService } from '../services/overlay/overlay.service';
import { EntitySummaryOverlayContainerComponent } from '../entity-summary/entity-summary-overlay-container/entity-summary-overlay-container.component';
import { columnDefinition, popUpComponent } from './prime-ng-array-d4.service';
import { ModalTextAreaForArrayComponent } from './modal-text-area-for-array/modal-text-area-for-array.component';

@Injectable({
  providedIn: 'root',
})
export class PrimgNgArrayD4ExternalComponentService {
  constructor(
    private getJsonService: GetJsonObjectService,
    private overlayService: OverlayService,
  ) {}

  public downloadLink(objectSelected: any, columnDefinitionName: any, event: any) {
    event.stopPropagation();
    const newWindow = window.open(lodhash.get(objectSelected, columnDefinitionName), '_blank');
    if (newWindow) {
      newWindow.focus();
    }
  }

  public mailLink(objectSelected: any, columnDefinitionName: any, event: any) {
    event.stopPropagation();
    const newWindow = window.open('mailto:' + lodhash.get(objectSelected, columnDefinitionName), '_blank');
    if (newWindow) {
      newWindow.focus();
    }
  }

  public phoneLink(objectSelected: any, columnDefinitionName: any, event: any) {
    event.stopPropagation();
    let phoneNumber = lodhash.get(objectSelected, columnDefinitionName);
    if (phoneNumber.length > 6) {
      const newWindow = window.open('tel:' + phoneNumber, '_blank');
      if (newWindow) {
        newWindow.focus();
      }
    }
  }

  public openLocation(objectSelected: any, columnDefinitionName: any, event: any) {
    let data = {
      gmapsLongitude: lodhash.get(objectSelected, columnDefinitionName).longitude,
      gmapsLatitude: lodhash.get(objectSelected, columnDefinitionName).latitude,
      markerName: objectSelected.displayText,
      height: '650px',
      width: '650px',
    };
    const ref = this.overlayService.open(GmapsViewComponent, data, {
      styleDefinition: { 'border-radius': '8px', width: '700px' },
    });
    ref.afterClosed$.subscribe((result: any) => {
      console.log(result);
    });
  }

  public openSummary(objectSelected: any, columnsDefinition: columnDefinition[]) {
    let jsonSummary: any = {};
    let data: any = {};
    let columnDefinitionMatching: any = columnsDefinition.find((column) => {
      return column.type == 'summary';
    });
    if (objectSelected.id != '') {
      this.getJsonService
        .getJson(
          encodeURI(environment.apiFlowConfig.apiUrlMd + 'summaries/' + objectSelected.id + '/d7c243aef496499898dea0b1399b3197'),
          undefined,
          { t: encodeURI(objectSelected.typeFullName) },
          true,
        )
        .pipe(first())
        .subscribe((summaryGetResult) => {
          if (summaryGetResult.error == undefined) {
            jsonSummary = summaryGetResult?.jsonSummary;
            data['jsonSummary'] = jsonSummary;
            data['error'] = '';
            data['entityDefinition'] = columnDefinitionMatching['datas']['entityDefinition'];
            data['summaryTitle'] = columnDefinitionMatching['datas']['summaryTitle'];

            data['eventType'] = {};
            data['eventType']['modalMode'] = 'floatting';
          }
          const ref = this.overlayService.open(
            EntitySummaryOverlayContainerComponent,
            data,
            { styleDefinition: { 'border-radius': '8px', width: '700px' } },
            false,
          );
          ref.afterClosed$.subscribe((result) => {
            console.log(result);
          });
        });
    }
  }

  public displayTextArea(columnName: string, object: any, rw: boolean): Observable<any> {
    let width: string = '750px';
    let height: string = '650px';

    const ref = this.overlayService.open(
      ModalTextAreaForArrayComponent,
      { texte: object[columnName], rw: rw },
      {
        styleDefinition: {
          'border-radius': '8px',
          width: width,
          height: height,
          position: 'fixed',
          top: 'calc(50% - 325px)',
          left: 'calc(50% - 375px)',
        },
      },
    );
    return ref.afterClosed$.pipe(
      map((result: any) => {
        if (result.data != undefined) {
          object[columnName] = result.data;
          let eventToWrite = {
            originalEvent: { code: 'Enter', target: { value: result.data } },
            data: object,
            field: columnName,
          };
          return eventToWrite;
        } else return null;
      }),
    );
  }

  public showPopUp(popUpCmp: popUpComponent, object: any, event: any = undefined): Observable<any> {
    let styleDefinition: any = {};

    let width: string = '750px';
    let height: string = '900px';
    if (popUpCmp.data.cmpWidth != null) width = popUpCmp.data.cmpWidth.toString() + 'px';
    if (popUpCmp.data.cmpHeight != null) height = popUpCmp.data.cmpHeight.toString() + 'px';
    styleDefinition = { 'border-radius': '8px', width: width, height: height };

    if (popUpCmp.data['modalMode'] == 'floattingPointerEvent') {
      styleDefinition['position'] = 'fixed';
      styleDefinition['top'] = 30 + event.clientY + 'px';
      styleDefinition['left'] = event.clientX - 10 + 'px';
    } else if (popUpCmp.data['modalMode'] == 'floatting') {
    }

    if (popUpCmp.styleDefinition != undefined) styleDefinition = popUpCmp.styleDefinition;

    const ref = this.overlayService.open(popUpCmp.component, { eventType: popUpCmp.data, item: object }, { styleDefinition: styleDefinition });
    return ref.afterClosed$.pipe(
      map((result: any) => {
        if (result.data != null) return result;
        else return null;
      }),
    );
  }
}
